import { h } from "preact";

type props = {};

export default function ({}: props) {
  return <div>Not Found</div>;
}
